import React from "react";
import Head from "next/head";
import { useRouter } from "next/router";
import { defaultSchema } from "../utils/constants";

interface MetaTagProps {
  metaTitle: string;
  metaDescription: string;
  src?: string;
  keywords?: string;
  robotsMeta?: string;
  ogimage?: string;
  twitterimage?: string;
  isCustomSchema?: boolean | null;
  schemaJson: any;
  jotforms?: any;
  canonicalUrl?: string; 
  isBlogPage?: boolean;
}

export const MetaTagsComp: React.FC<MetaTagProps> = (props) => {
  const router = useRouter()
 
  const currentUrl = process.env.NEXT_PUBLIC_BASE_URL + (router.asPath || '')
  const {
    metaTitle,
    metaDescription,
    src,
    keywords,
    robotsMeta,
    ogimage,
    twitterimage,
    isCustomSchema,
    schemaJson,
    jotforms,
    canonicalUrl,
    isBlogPage
  } = props;
  const structuredJSON = isCustomSchema && schemaJson ? schemaJson : defaultSchema

  const removeQueryParameters = (url: string) => {
      const currentUrl = url;
      const queryIndex = currentUrl.indexOf('?');
      return queryIndex !== -1 ? currentUrl.slice(0, queryIndex) : currentUrl;
  };

  const cleanCanonicalUrl = canonicalUrl ? removeQueryParameters(canonicalUrl) : removeQueryParameters(currentUrl);
 

  return (
    <>
      <Head>
        <title>{metaTitle}</title>
        <meta name="description" content={metaDescription} />
        {keywords && <meta name="keywords" content={keywords} />}
        {robotsMeta && <meta name="robots" content={robotsMeta} />}
        {metaTitle && <meta property="og:title" content={metaTitle} />}
        {metaDescription && (
          <meta property="og:description" content={metaDescription} />
        )}
        <meta property="og:url" content={isBlogPage ? cleanCanonicalUrl : currentUrl}  />
        <meta property="og:type" content="Organization" />
        <meta property="og:image" content={ogimage || "https://www.studies-overseas.com/kc_schema_logo.png"} />
        <meta property="og:site_name" content={isBlogPage ? cleanCanonicalUrl : currentUrl}  />
        <link rel="canonical" href={cleanCanonicalUrl || canonicalUrl} />
        {src && <script src={src} />}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@KCOverseasEdu" />
        <meta name="twitter:creator" content="@KCOverseasEdu" />
        {metaTitle && <meta name="twitter:title" content={metaTitle} />}
        {metaDescription && <meta name="twitter:description" content={metaDescription} />}
        <meta name="twitter:image" content={twitterimage || "https://www.studies-overseas.com/kc_schema_logo.png"} />
        {structuredJSON && <script
          className="structured-data-list"
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredJSON) }}
        ></script>}
      </Head>
    </>
  );
};
